import { useParams } from "react-router-dom";

export const useInvoiceSpecificationId = () => {
  const params = useParams();
  return params.invoiceSpecificationId as string;
};
